import { render, staticRenderFns } from "./SubmissionPreview.vue?vue&type=template&id=33aebeaa&scoped=true&"
import script from "./SubmissionPreview.vue?vue&type=script&lang=js&"
export * from "./SubmissionPreview.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionPreview.vue?vue&type=style&index=0&id=33aebeaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aebeaa",
  null
  
)

export default component.exports